<template>
  <ul class='pagination pagination-centered pager'>
    <li id="first_page_0" v-bind:class="{disabled: isFirst}">
      <a name="nav" class="preview" href="javascript:;" @click="toFirst">首页&lt;&lt;</a>
    </li>
    <li id="pre_page_0" v-bind:class="{disabled: isFirst}">
      <a name="nav" class="preview" href="javascript:;" @click="forward">&lt;前页</a>
    </li>
    <li>
      <span>
      <input style="width:30px;height:18px;text-align:right" :value="this.pager.pageIndex" id="page_nav_0" @keypress="goto" onfocus="return this.select();" onmouseover="return this.select();">
      <span id="page_tot_0" class="disabled">/ {{size}}</span>
      </span>
    </li>
    <li id="next_page_0" v-bind:class="{disabled: isLast}">
      <a name="nav" href="javascript:;" @click="backward">后页&gt;</a>
    </li>
    <li id="last_page_0" v-bind:class="{disabled: isLast}">
      <a name="nav" href="javascript:;" @click="toLast">&gt;&gt;末页</a>
    </li>
    <li class="disabled">
      <a href="javascript:;">共{{totalCount}}条</a>
    </li>
  </ul>
</template>
<script>
  import {mapState} from 'vuex'
  import mixins from '../../mixins/index'

  export default {
    name: 'pager',
    mixins: mixins,
    methods: {
      toFirst () {
        if (this.pager.pageIndex !== 1) {
          this.$store.dispatch('setPageIndex', 1)
          this.action()
        }
      },
      forward () {
        if (this.pager.pageIndex > 1) {
          this.$store.dispatch('setPageIndex', this.pager.pageIndex - 1)
          this.action()
        }
      },
      backward () {
        if (this.pager.pageIndex < this.size) {
          this.$store.dispatch('setPageIndex', this.pager.pageIndex + 1)
          this.action()
        }
      },
      toLast () {
        if (this.pager.pageIndex !== this.size) {
          this.$store.dispatch('setPageIndex', this.size)
          this.action()
        }
      },
      goto () {
        let evt = arguments[0]
        if (evt.key === 'Enter') {
          let val = Number.parseInt(evt.target.value)
          console.log('val = ' + val)
          if (val && val <= this.size && val >= 1) {
            this.$store.dispatch('setPageIndex', val)
            this.action()
          }
        }
      }
    },
    computed: {
      isFirst () {
        return this.pager.pageIndex === 1
      },
      isLast () {
        return this.pager.pageIndex === this.size
      },
      size () {
        return Math.ceil(this.totalCount / this.pageSize)
      },
      ...mapState({
        pager: state => state.pager
      })
    },
    props: {
      totalCount: Number,
      pageIndex: Number,
      pageSize: Number,
      nextOffset: Number,
      action: Function
    }
  }
</script>
<style scoped>
  .pager {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// Pager.vue?52ab33ba